<script>

    import SubChart from "../charts/subcharts/subreview.svelte"

    export let chartType;
    export let chartConfig;
    //export let chartTextContent;
    export let currentPage;
    export let total;
    export let keywordTitle;

    let chartTextContent = {
        'reviews': {
            'overview': {
                'info': {
                    'title': 'Bewertungen - Übersicht',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie während des gewählten Zeitraumes erhalten haben.<br />\n' +
                        '        <br />\n' +
                        '        Darstellungen:\n' +
                        '        <ul>\n' +
                        '            <li><strong>Rating</strong> - zeigt die positiven, neutralen und negativen Bewertungen separat an</li>\n' +
                        '            <li><strong>Geschlecht</strong> - zeigt Bewertungen von Frauen, Männern und unbekannter Herkunft separat an</li>\n' +
                        '        </ul>'
                },
                'data': {
                    'title': 'Übersicht',
                }
            },
            'daily': {
                'info': {
                    'title': 'Bewertungen - Verteilung Wochentage',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie pro Tag während des gewählten Zeitraumes erhalten haben.'
                },
                'data': {
                    'title': 'Verteilung Wochentage',
                }
            },
            'monthly': {
                'info': {
                    'title': 'Bewertungen - Verteilung Monate',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie pro Monat während des gewählten Zeitraumes erhalten haben.'
                },
                'data': {
                    'title': 'Verteilung Monate',
                }
            },
            'platforms': {
                'info': {
                    'title': 'Bewertungen - Verteilung Portale',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie auf jedem verknüpften Portal erhalten haben.'
                },
                'data': {
                    'title': 'Verteilung Portale',
                }
            }
        },
        'keywords': {
            'overview': {
                'info': {
                    'title': 'Keywords - Übersicht',
                    'content': 'Dieses Chart zeigt Ihnen alle Keywords aus Ihren Bewertungen während des gewählten Zeitraumes an.\n' +
                        '                Ein Schlagwort wird als Keyword gezählt, wenn es mehr als zweimal in Ihren Bewertungen verwendet wurde.<br />\n' +
                        '                <br />\n' +
                        '                Klicken Sie auf ein Keyword oder benutzen Sie das Suchfeld, um detaillierte Charts für ein Keyword anzuzeigen.<br />\n' +
                        '                <br />\n' +
                        '                Darstellungen:\n' +
                        '                <ul>\n' +
                        '                    <li><strong>Top 20</strong> - zeigt die 20 meistbenutzten Keywords an</li>\n' +
                        '                </ul>'
                },
                'data': {
                    'title': 'Keyword - Übersicht',
                }
            }
        },
        // 'errore': {
        //     'de': 'Keine Daten verfügbar.',
        //     'en': 'no data found.',
        // }
        'errore': 'Keine Daten verfügbar.'

    }

</script>

<SubChart
    chartConfig={chartConfig}
    text={chartTextContent}
    chartType={chartType}
    currentPage={currentPage}
    total={total}
    keywordTitle={keywordTitle}
/>





